'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EMITTER_STYLE = {
    position: 'absolute'
};

var easeInOutCubic = function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};

var randRange = function randRange(min, max) {
    return Math.random() * (max - min) + min;
};

var getStyle = function getStyle(particle) {
    var age = particle.age / particle.maxAge;
    var rotate = particle.rotate;
    var scale = Math.sin(age) * 2;
    var opacity = easeInOutCubic(1 - age);

    var transform = 'translate3d(' + particle.x + 'px, ' + particle.y + 'px, 0) rotate(' + rotate + 'deg) scale(' + scale + ')';

    return {
        transform: transform,
        WebkitTransform: transform,
        opacity: opacity,
        position: 'absolute',
        left: 0,
        top: 0
    };
};

var Particle = function Particle(_ref) {
    var particle = _ref.particle,
        iconName = _ref.iconName,
        children = _ref.children;
    return _react2.default.createElement(
        'div',
        { className: 'Particle', style: getStyle(particle) },
        children
    );
};

Particle.propTypes = {
    particle: _propTypes2.default.object,
    iconName: _propTypes2.default.string,
    children: _propTypes2.default.element
};

var updateParticle = function updateParticle(particle) {
    return {
        x: particle.x + particle.vx,
        y: particle.y + particle.vy,
        vx: particle.vx + particle.gravity.x,
        vy: particle.vy + particle.gravity.y,
        rotate: particle.rotate + particle.vr,
        vr: particle.vr * 0.99,
        age: particle.age + 1,
        maxAge: particle.maxAge,
        gravity: particle.gravity
    };
};

var ParticleEmitter = function (_React$Component) {
    _inherits(ParticleEmitter, _React$Component);

    function ParticleEmitter(props) {
        _classCallCheck(this, ParticleEmitter);

        var _this = _possibleConstructorReturn(this, (ParticleEmitter.__proto__ || Object.getPrototypeOf(ParticleEmitter)).call(this, props));

        _this.animateParticles = function () {
            var _this$props = _this.props,
                stopAfter = _this$props.stopAfter,
                _this$props$particleF = _this$props.particleFrequency,
                particleFrequency = _this$props$particleF === undefined ? 20 : _this$props$particleF;


            if (!_this.animate) return;

            var particles = _this.state.particles;

            var updated = particles.map(updateParticle).filter(function (particle) {
                return particle.age < particle.maxAge;
            });

            _this.setState({
                particles: updated
            });

            _this.addTick++;
            if (_this.addTick % particleFrequency === 0) _this.addParticle();

            if (stopAfter && _this.totalCount > stopAfter && !updated.length) {
                _this.animate = false;
            }

            requestAnimationFrame(_this.animateParticles);
        };

        _this.addParticle = function () {
            var _this$props2 = _this.props,
                _this$props2$maxAge = _this$props2.maxAge,
                maxAge = _this$props2$maxAge === undefined ? 150 : _this$props2$maxAge,
                stopAfter = _this$props2.stopAfter,
                _this$props2$initalVe = _this$props2.initalVelocityX,
                initalVelocityX = _this$props2$initalVe === undefined ? {
                max: 2,
                min: -2
            } : _this$props2$initalVe,
                _this$props2$initalVe2 = _this$props2.initalVelocityY,
                initalVelocityY = _this$props2$initalVe2 === undefined ? {
                max: -4,
                min: -8
            } : _this$props2$initalVe2,
                _this$props2$rotation = _this$props2.rotationVelocity,
                rotationVelocity = _this$props2$rotation === undefined ? {
                max: 10,
                min: -10
            } : _this$props2$rotation,
                _this$props2$initalPo = _this$props2.initalPositionRect,
                initalPositionRect = _this$props2$initalPo === undefined ? {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            } : _this$props2$initalPo,
                _this$props2$gravity = _this$props2.gravity,
                gravity = _this$props2$gravity === undefined ? {
                x: 0,
                y: 0.1
            } : _this$props2$gravity;


            if (stopAfter && _this.totalCount > stopAfter) return;

            var particles = _this.state.particles;


            var newParticle = {
                x: randRange(initalPositionRect.x, initalPositionRect.width),
                y: randRange(initalPositionRect.y, initalPositionRect.height),
                vx: randRange(initalVelocityX.min, initalVelocityX.max),
                vy: randRange(initalVelocityY.min, initalVelocityY.max),
                vr: randRange(rotationVelocity.min, rotationVelocity.max),
                rotate: 0,
                age: 0,
                maxAge: maxAge,
                gravity: gravity
            };

            _this.totalCount++;

            _this.setState({
                particles: [].concat(_toConsumableArray(particles), [newParticle])
            });
        };

        _this.state = {
            particles: []
        };
        return _this;
    }

    _createClass(ParticleEmitter, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.animate = true;
            this.addTick = 0;
            this.totalCount = 0;
            this.animateParticles();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.animate = false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className;
            var particles = this.state.particles;


            return _react2.default.createElement(
                'div',
                { className: 'ParticleEmitter ' + className, style: EMITTER_STYLE },
                particles.map(function (particle, i) {
                    return _react2.default.createElement(Particle, { particle: particle, key: i, children: children });
                })
            );
        }
    }]);

    return ParticleEmitter;
}(_react2.default.Component);

ParticleEmitter.propTypes = {
    maxAge: _propTypes2.default.number,
    stopAfter: _propTypes2.default.number,
    particleFrequency: _propTypes2.default.number,
    className: _propTypes2.default.string,

    gravity: _propTypes2.default.shape({
        x: _propTypes2.default.number,
        y: _propTypes2.default.number
    }),

    initalVelocityX: _propTypes2.default.shape({
        min: _propTypes2.default.number,
        max: _propTypes2.default.number
    }),

    initalVelocityY: _propTypes2.default.shape({
        min: _propTypes2.default.number,
        max: _propTypes2.default.number
    }),

    rotationVelocity: _propTypes2.default.shape({
        min: _propTypes2.default.number,
        max: _propTypes2.default.number
    }),

    initalPositionRect: _propTypes2.default.shape({
        x: _propTypes2.default.number,
        y: _propTypes2.default.number,
        width: _propTypes2.default.number,
        height: _propTypes2.default.number
    }),

    children: _propTypes2.default.element
};

exports.default = ParticleEmitter;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/animations/ParticleEmitter.js
// module id = 1700
// module chunks = 0